import { gql } from '@apollo/client';

export const SET_DEFAULT_PAYMENT_METHOD = gql`
  mutation SetStripeDefaultPaymentMethod($paymentMethodId: String!) {
    setStripeDefaultPaymentMethod(paymentMethodId: $paymentMethodId) {
      id
      stripeCustomerId
      defaultPaymentMethodId
      created
      updated
    }
  }
`;
